<template>
  <div class="card">
    <div class="card-body">
      <h5 class="card-title">Manual Deposit</h5>
      <div class="row">
        <div class="col">
          <div class="alert alert-warning" v-show="showManualDepositInfo">
            <p class="text-dark">
              Terkadang beberapa transaksi terlewat dari proses auto
              singkronisasi yang mungkin ada faktor eksternal diluar aplikasi
              kami.
            </p>
            <p class="text-dark">
              Kamu dapat memasukkan transaksi hash pada input dibawah ini.
              <span
                style="
                  font-weight: bold;
                  cursor: pointer;
                  text-decoration: underline;
                  color: blue;
                "
                @click="showManualDepositFormAction"
              >
                here
              </span>
            </p>
          </div>

          <form
            @submit.prevent="submitFormManualDeposit"
            v-show="showManualDepositForm"
          >
            <div class="row mt-2">
              <label class="col-md-4 text-right">Chain:</label>
              <div class="col-md-8">
                <select v-model="manualDeposit.chain_name" class="form-control">
                  <option value="ethereum">Ethereum</option>
                  <option value="arbitrum">Arbitrum</option>
                </select>
              </div>
            </div>

            <div class="row mt-2">
              <label class="col-md-4 text-right">Tx Hash:</label>
              <div class="col-md-8">
                <input
                  type="text"
                  v-model="manualDeposit.txhash"
                  class="form-control"
                />
              </div>
            </div>

            <div class="row mt-2">
              <div class="col-md-4">&nbsp;</div>
              <div class="col-md-8">
                <button
                  type="submit"
                  class="btn btn-light"
                  style="margin-right: 10px"
                >
                  Submit
                </button>
                <a href="#" @click="showManualDepositInfoAction"> Batal </a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// node_modules
import Cookies from "js-cookie";

// applibs
import themain from "@/applibs/themain.js";
import thestore from "@/applibs/thestore.js";

// components

export default {
  components: {},
  props: {
    currency: {
      type: String,
      required: true,
    },
    activeCurrencyObj: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      themain,
      token: Cookies.get("jwt") || Cookies.get("usid"),
      usid: Cookies.get("usid"),
      ethereumAddress: "",

      showManualDepositInfo: true,
      showManualDepositForm: false,

      manualDeposit: {
        txhash: "",
        chain_name: "",
      },
    };
  },

  async mounted() {
    // console.log('self.currency', this.currency);
    // console.log("self.activeCurrencyObj", self.activeCurrencyObj);
  },

  methods: {
    showManualDepositFormAction() {
      var self = this;
      self.showManualDepositInfo = false;
      self.showManualDepositForm = true;
    },
    showManualDepositInfoAction() {
      var self = this;
      self.showManualDepositInfo = true;
      self.showManualDepositForm = false;
    },

    async submitFormManualDeposit() {
      var self = this;
      var res;
      // console.log('self.token', self.manualDeposit.chain_name);
      res = await thestore.postEthManualDeposit(
        self.token,
        self.manualDeposit.txhash,
        self.manualDeposit.chain_name
      );
      if (res.success == true) {
        alert("Manual deposit success");
        self.$router.go();
      } else {
        alert(res.msg);
      }
    },
  },
};
</script>
